<template>
    <el-container class="file-constainer">
        <el-aside v-if="isShowLeft" width="280px">
            <div>  
                <el-tree
                    highlight-current
                    node-key="id"
                    ref="tree"
                    :current-node-key="selectNodeId"
                    :default-expanded-keys="idExpandedArr"
                    :expand-on-click-node="false"
                    :data="archiveTemplateTreeData"
                    :props="defaultProps"
                    @node-click="handleTreeNode"
                />
            </div>
        </el-aside>
        <SideLeftTree  @changeLeftTree="setShowleftList"/>
        <el-main>
            <div class="tools-bar">
                <div class="tools-search" @keyup.enter="handleSearch">
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item v-if="isApprovalMode" label="流程名称">
                            <el-input style="width: 200px;" @click.native="chooseProcess" v-model="searchParams.processInstanceName" ></el-input>
                        </el-form-item>
                        <el-form-item v-if="isApprovalMode" label="审核状态">
                            <el-select style="width:120px;" v-model="searchParams.approvalStatus" @change="handleSearch" placeholder="请选择">
                                <el-option
                                    v-for="item in approvalStatusArr"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="文件名称">
                            <el-input maxlength="100" v-model.trim="searchParams.fileName" placeholder="" @blur="handleSearch">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="上传人员" >
                            <el-input style="width:100px" readonly v-model="selectedUser.selectedUserNames" @focus="chooseUser" ></el-input>
                            <UserOrgPop :multiple="false" :isShowUserOrg='isShowUserOrg'  :selectedUser="selectedUser" ref="userOrgPop" @nodeClick="selectTrigger"  />
                        </el-form-item>
                        <el-form-item>
                            <el-button class='print-class' v-permission="permission.archiveApprovalBtn" title='对选择的文件进行归档审批' type="primary" size="mini" icon="el-icon-receiving"  @click.stop="handleBathApprovalFiles()">批量审核</el-button>
                            <el-button class='print-class' v-if="!isFullScreen" type="primary" icon="el-icon-rank"  size="mini" @click.stop="handleFullScreen()">全屏</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <el-table :data="fileList" style="width: 100%" :border="true" v-loading="loading" @selection-change="handleSelectionChange" >
                <el-table-column v-if="isApprovalMode" type="selection" width="55"></el-table-column>
                <el-table-column prop="fileName" label="文件名称" :show-overflow-tooltip="true" width="150"></el-table-column>
                <!--<el-table-column prop="fileByteSize" label="文件大小" :show-overflow-tooltip="true" width="130" ></el-table-column>-->
                <el-table-column :show-overflow-tooltip="true" prop="fileByteSize" label="文件大小" width="130">
                    <template slot-scope="scope">
                        {{scope.row.fileByteSize | getfilesize }}
                    </template>
                </el-table-column>
                <el-table-column prop="fileType" label="文件类型" :show-overflow-tooltip="true" width="130" ></el-table-column>
                <el-table-column prop="processInstanceName" label="所属流程" :show-overflow-tooltip="true" width="130" ></el-table-column>
                <el-table-column prop="archiveLabel" label="档案目录" :show-overflow-tooltip="true" width="130" ></el-table-column>
                <el-table-column prop="created" label="创建时间" :show-overflow-tooltip="true" width="130" ></el-table-column>
                <el-table-column prop="trueName" label="创建人" :show-overflow-tooltip="true" width="130" ></el-table-column>
                <el-table-column  :show-overflow-tooltip="true" prop="approvalStatus" label="归档状态" width="80">
                    <template slot-scope="scope">
                        <!-- <template v-if="scope.row.approvalStatus === 0" >草稿</template> -->
                        <template v-if="scope.row.approvalStatus === 1" >审核中</template>
                        <template v-if="scope.row.approvalStatus === 2" >归档通过</template>
                        <template v-if="scope.row.approvalStatus === 3" >归档驳回</template>
                        <template v-if="scope.row.approvalStatus === 0 || scope.row.approvalStatus === 99" >未归档</template>
                    </template>
                </el-table-column>
                <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="applyTime" label="归档申请时间"  width="120" ></el-table-column>
                <el-table-column  :show-overflow-tooltip="true" prop="trueName" label="审核人" width="60" >
                    <template slot-scope="scope">
                        {{scope.row.approvaler}}
                    </template>
                </el-table-column>
                <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="approvalTime" label="审核时间"  width="140" ></el-table-column>
                <el-table-column  :show-overflow-tooltip="true" :sortable="true" prop="approveDesc" label="审核描述"  width="140" ></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="isApprovalMode && scope.row.approvalStatus === 1" v-permission="permission.archiveApprovalBtn" title='对文件归档审批' type="primary" size="mini" icon="el-icon-receiving" circle  @click.stop="handleSingleApprovalFileById(scope.row)"></el-button>
                        <el-button type="primary" size="mini" icon="el-icon-download" title="下载" circle @click.stop="handleDownLoad(scope.row)"></el-button>
                        <el-button type="success" size="mini" icon="el-icon-view" title="预览" circle @click="previewFile(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row type="flex" justify="end">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :total="page.totalPageNum"
                    :current-page="page.currentPage"
                    :page-size="page.pageSize"
                    @current-change="queryFormData"
                />
            </el-row>
        </el-main>
        <el-dialog
            :title="approvalDialogTile"
            :visible.sync="isShowApprovalDialog"
            :key="loadTimer"
            append-to-body
            >
            <el-form :model="approvalInfo" ref="approvalInfoForm" size="mini" label-width="120px">
                <el-row>
                    <el-form-item label="审批文件">
                        <el-input disabled type="textarea" :autosize="{ minRows: 3, maxRows: 10}" v-model="selectedFiles.selectedFileNames"></el-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item  label="审批结论">
                    <el-radio-group v-model="approvalInfo.status" size="mini" class="exec-type">
                        <el-radio :label="2">通过</el-radio>
                        <el-radio :label="3">驳回</el-radio>
                    </el-radio-group>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item label="审批描述"  prop="approveDesc">
                    <el-input placeholder="请输入内容"  type="textarea" :autosize="{ minRows: 6, maxRows: 10}" v-model="approvalInfo.approveDesc"></el-input>
                    </el-form-item>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowApprovalDialog = false">取 消</el-button>
                <el-button type="primary" @click="handleFinalApproval" :loading="startProcessloading">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="选择所属流程"
            :visible.sync="isShowProcessListDialog"
            append-to-body
            width = "60%">
            <ProcessPop  :field="{}" ref="processSelect" :formData="{}" @nodeClick="processSelectTrigger"/>
            <span slot="footer" class="dialog-footer">
                <el-button  type="primary" @click="handleClickOk">确定</el-button>
            </span>
        </el-dialog>
    </el-container>
</template>

<script>
    import { approvalArchiveFileByIds, getUserList, getArchiveTemplateTreeList, getFilesListByTemplateTreeId, downloadFiles } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';
    import { isEmpty } from 'lodash';
    import { CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN, API_FILE_DOWNLOAD } from '@/common/constants';
    import { getPreviewFileUrl } from '@/utils/grocer';

    export default {
        components: {
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                isShowProcessListDialog: false,
                loadTimer: '',
                selectedFiles: {
                    selectedFileIds: '', // 选中的文件ID
                    selectedFileNames: '' // 选中的文件名称
                },
                approvalInfo: {
                    templateId: '',
                    processInstanceId: '',
                    status: 2,
                    approveDesc: ''
                },
                approvalDialogTile: '文件审核',
                startProcessloading: false,
                isShowApprovalDialog: false,
                idExpandedArr: [],
                isShowLeft: true,
                approvalStatusArr: [{
                    value: 999,
                    label: '全部'
                }, {
                    value: 99,
                    label: '未归档'
                }, {
                    value: 1,
                    label: '审核中'
                }, {
                    value: 2,
                    label: '归档通过'
                }, {
                    value: 3,
                    label: '归档驳回'
                }],
                isShowUserOrg: false,
                selectedUser: {
                    selectedUserIds: '',
                    selectedUserNames: ''
                },
                userList: [],
                selectNodeId: 0,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                searchParams: {
                    processInstanceId: '',
                    processInstanceName: '',
                    approvalStatus: 999,
                    userId: '',
                    trueName: '',
                    fileName: '',
                    templateName: '',
                    sourceTreeId: '',
                    templateId: ''
                },
                loading: false,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                fileList: [],
                archiveTemplateTreeData: [], // 档案模板树
                permission: {
                    archiveApprovalBtn: [// 业务档案文件审核
                        CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN
                    ]
                }
            };
        },
        filters: {// 如下这样写
            getfilesize: function (size) {
                // console.log(size);
                if (!size) {
                    return '';
                }
                var num = 1024.00; // byte
                if (size < num) { return size + '(B)'; }
                if (size < Math.pow(num, 2)) { return (size / num).toFixed(2) + '(K)'; } // kb
                if (size < Math.pow(num, 3)) { return (size / Math.pow(num, 2)).toFixed(2) + '(M)'; } // M
                if (size < Math.pow(num, 4)) { return (size / Math.pow(num, 3)).toFixed(2) + '(G)'; } // G
                return (size / Math.pow(num, 4)).toFixed(2) + '(T)'; // T
            }
        },
        props: {
            isApprovalMode: {// 审核模式
                type: Boolean,
                default: false
            },
            templateId: {
                type: String
            },
            processInstanceId: {
                type: String,
                default: ''
            },
            taskInstanceId: {
                type: String,
                default: ''
            },
            formId: {
                type: String,
                default: ''
            },
            isFullScreen: { // 是否全屏
                type: Boolean,
                default: true
            }
        },
        computed: {
        },
        created () {
            this.searchParams.processInstanceId = this.processInstanceId;
            this.searchParams.taskInstanceId = this.taskInstanceId;
            if (this.isApprovalMode) {
                this.searchParams.approvalStatus = 1;
            }
            this._initPage().then(val => {
                // 初始化默认展开到第二级
                if (this.archiveTemplateTreeData && this.archiveTemplateTreeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.archiveTemplateTreeData[0].id);
                }
            });
            this.queryUserList('');
        },
        watch: { // 监听传入的appId变化，触发事件
            templateId (val) {
                this._initPage();
            }
        },
        methods: {
            async _initPage () {
                // console.log("============"+this.templateId);
                this.searchParams.templateId = this.templateId;
                let treeData = await getArchiveTemplateTreeList({templateId: this.templateId});
                this.archiveTemplateTreeData = treeData;
                if (this.archiveTemplateTreeData !== []) {
                    this.searchParams.sourceTreeId = this.archiveTemplateTreeData[0].id;
                    this._getFormData();
                }
            },
            async _getFormData () {
                this.loading = true;
                let formData = await getFilesListByTemplateTreeId(Object.assign({}, {
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize,
                    formId: this.formId
                }, this.searchParams));
                this.fileList = formData.data;
                this.page = {
                    currentPage: formData.currentPage,
                    pageSize: formData.pageSize,
                    totalPageNum: formData.totalPageNum
                };
                this.loading = false;
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this._getFormData();
            },
            handleSearch () {
                this.queryFormData(1);
            },
            handleTreeNode (data, node, tree) {
                this.searchParams.sourceTreeId = data.id;
                this.handleSearch();
            },
            async queryUserList (userName) {
                this.loading = true;
                let userData = await getUserList({ name: userName });
                this.userList = userData.data;
                this.loading = false;
            },
            chooseUser () {
                setTimeout(() => { // 初始化
                    this.$refs.userOrgPop._initPage();
                }, 0);
                this.isShowUserOrg = true;
            },
            selectTrigger (selected) {
                this.searchParams.userId = selected.selectedUserIds;
                this.handleSearch();
            },
            handleDownLoad (row) { // 下载
                // console.log(row.filePath);
                if (row.filePath) {
                    let url = `${API_FILE_DOWNLOAD}${row.filePath}`;
                    this.download(url);
                }
            },
            download (url) {
                downloadFiles(url);
                // var iframe = document.createElement('iframe');
                // iframe.style.display = 'none';
                // iframe.src = url;
                // document.body.appendChild(iframe);
            },
            async previewFile (row) {
                let previewUrl = await getPreviewFileUrl(row);
                if (previewUrl) {
                    let tempwindow = window.open();
                    tempwindow.location = previewUrl;
                }
            },
            setShowleftList (isShowLeft) {
                this.isShowLeft = isShowLeft;
            },
            handleSelectionChange (rows) {
                this.selectedFiles.selectedFileIds = '';
                this.selectedFiles.selectedFileNames = '';
                if (rows) {
                    if (Array.isArray(rows)) {
                        rows.forEach(row => {
                            if (row) {
                                if (isEmpty(this.selectedFiles.selectedFileIds)) {
                                    this.selectedFiles.selectedFileIds = row.id;
                                    this.selectedFiles.selectedFileNames = row.fileName;
                                } else {
                                    this.selectedFiles.selectedFileIds = this.selectedFiles.selectedFileIds + ',' + row.id;
                                    this.selectedFiles.selectedFileNames = this.selectedFiles.selectedFileNames + ',' + row.fileName;
                                }
                            }
                        });
                    } else {
                        this.selectedFiles.selectedFileIds = rows.id;
                        this.selectedFiles.selectedFileNames = rows.fileName;
                    }
                }
                // console.log(this.selectedFiles);
            },
            async handleBathApprovalFiles () {
                this.loadTimer = new Date().getTime();
                if (!isEmpty(this.selectedFiles.selectedFileIds)) {
                    this.approvalDialogTile = '批量归档审核';
                    this.isShowApprovalDialog = true;
                    this.startProcessloading = false;
                    this.approvalInfo.templateId = this.templateId;
                    this.approvalInfo.fileId = this.selectedFiles.selectedFileIds;
                } else {
                    this.$message.warning('请选择需要审核的文件');
                }
            },
            async handleFinalApproval () {
                let isValid = false;
                this.$refs['approvalInfoForm'].validate((valid) => {
                    if (valid) {
                        isValid = true;
                    } else {
                        isValid = false;
                    }
                });
                if (!isValid) {
                    return false;
                }
                this.startProcessloading = true;
                await approvalArchiveFileByIds(this.approvalInfo);
                await this.handleSearch();
                this.startProcessloading = false;
                this.isShowApprovalDialog = false;
                // 审核结束
                this.selectedFiles = {
                    selectedFileIds: '', // 选中的文件ID
                    selectedFileNames: '' // 选中的文件名称
                };
            },
            handleSingleApprovalFileById (row) {
                this.loadTimer = new Date().getTime();
                this.selectedFiles.selectedFileIds = row.id;
                this.selectedFiles.selectedFileNames = row.fileName;
                this.approvalDialogTile = '文件归档审核';
                this.isShowApprovalDialog = true;
                this.startProcessloading = false;
                this.approvalInfo.templateId = this.templateId;
                this.approvalInfo.fileId = this.selectedFiles.selectedFileIds;
            },
            chooseProcess () {
                this.isShowProcessListDialog = true;
            },
            processSelectTrigger (selected) { // 选择流程
                this.searchParams.processInstanceId = selected.id;
                this.searchParams.processInstanceName = selected.label;
            },
            async handleClickOk () {
                this.handleSearch();
                this.isShowProcessListDialog = false;
            },
            handleFullScreen () {
                this.$emit('handleFullScreen');
            }
        }
    };
</script>

<style lang="less">
    .file-constainer {
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
    .span-line{
      color:rgb(19, 206, 102);
    }
    .span-line:hover{
        text-decoration:underline;
    }
    .span-line-right{
        margin-right: 2px;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/pages/document/Archive/ArchiveView2/DocView/DocView.vue